<template>
  <div class="crawl-page">
    <div class="dashboard-container">
      <!-- HEADER -->
      <div class="top-header d-none">
        <div>
          <h1>Crawl Data Manager</h1>

          <p>Quản lý và kiểm thử dữ liệu crawler API</p>
        </div>

        <div class="avatar-box">
          <i class="bi bi-person-fill"></i>
        </div>
      </div>

      <!-- CONTENT -->
      <div class="row g-4">
        <!-- LEFT -->
        <div class="col-lg-4">
          <div class="glass-card">
            <h3 class="section-title">Global Parameters</h3>

            <div class="row g-3">
              <div class="col-12">
                <label class="label-title"> updatedAt </label>

                <div class="label-desc">Crawl Timestamp</div>

                <input type="text" v-model="updatedAt" class="custom-input" />
              </div>

              <div class="col-12">
                <label class="label-title"> funcId </label>

                <div class="label-desc">API Function ID</div>

                <input type="number" v-model="funcId" class="custom-input" />
              </div>
            </div>

            <!-- BUTTON -->
            <button @click="sendRequest" :disabled="loading" class="submit-btn">
              <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>

              {{ loading ? "Đang gửi..." : "Gửi dữ liệu API" }}
            </button>

            <!-- RESPONSE -->
            <div v-if="responseData" class="response-box">
              <div class="response-title">RESPONSE JSON</div>

              <pre>{{ responseData }}</pre>
            </div>
          </div>
        </div>

        <!-- RIGHT -->
        <div class="col-lg-8">
          <div class="glass-card h-100">
            <!-- TOP -->
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h3 class="section-title m-0">Danh sách sản phẩm</h3>

              <button @click="addProduct" class="btn-add">+</button>
            </div>

            <!-- SCROLL -->
            <div class="right-scroll">
              <!-- GRID -->
              <div class="product-grid">
                <div
                  v-for="(item, index) in products"
                  :key="index"
                  class="product-wrapper"
                >
                  <!-- HEADER -->
                  <div class="product-top">
                    <div class="product-left">
                      <span class="arrow"> ▼ </span>

                      <span class="product-name"> Sản phẩm #{{ index + 1 }} </span>
                    </div>

                    <div class="d-flex align-items-center gap-2 d-none">
                      <button class="mini-add">ADD NEW</button>

                      <button @click="removeProduct(index)" class="mini-remove">✕</button>
                    </div>
                  </div>

                  <!-- BODY -->
                  <div class="product-body">
                    <div class="row g-3">
                      <div class="col-6">
                        <div class="input-icon">
                          <span> 📦 </span>

                          <input
                            v-model="item.name"
                            placeholder="Tên sản phẩm"
                            class="custom-input"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="input-icon">
                          <span> 💲 </span>

                          <input
                            type="number"
                            v-model.number="item.price"
                            placeholder="Giá"
                            class="custom-input"
                          />
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="input-icon">
                          <span> 🔗 </span>

                          <input
                            v-model="item.url"
                            placeholder="https://..."
                            class="custom-input"
                          />
                        </div>
                      </div>

                      <div class="col-md-6 d-none">
                        <select v-model="item.status" class="custom-input">
                          <option value="success">success</option>

                          <option value="error">error</option>

                          <option value="pending">pending</option>
                        </select>
                      </div>

                      <div class="col-12 d-none">
                        <input
                          v-model="item.errorReason"
                          placeholder="Error Reason"
                          class="custom-input"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- END SCROLL -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { MD5 } from "crypto-js";
export default {
  name: "CrawlDashboard",

  data() {
    return {
      loading: false,
      funcId: 1900,
      updatedAt: "2026-05-20 17:15:40",
      responseData: null,
      products: [
        {
          index: 1,
          name: "iPhone 17 Pro Max 256GB",
          url: "https://cellphones.com.vn/iphone-17-pro-max.html",
          price: 36990000,
          status: "success",
          errorReason: null,
        },

        {
          index: 2,
          name: "iPhone 17 Pro 256GB",
          url: "https://cellphones.com.vn/iphone-17-pro.html",
          price: 34590000,
          status: "success",
          errorReason: null,
        },

        {
          index: 3,
          name: "iPhone Air 256GB",
          url: "https://cellphones.com.vn/iphone-air-256gb.html",
          price: 22890000,
          status: "success",
          errorReason: null,
        },

        {
          index: 4,
          name: "iPhone 17 256GB",
          url: "https://cellphones.com.vn/iphone-17-256gb.html",
          price: 24390000,
          status: "success",
          errorReason: null,
        },

        {
          index: 5,
          name: "iPhone 17e 256GB",
          url: "https://cellphones.com.vn/iphone-17e.html",
          price: 17490000,
          status: "success",
          errorReason: null,
        },

        {
          index: 6,
          name: "iPad Pro M4 11 inch Wifi 256GB",
          url: "https://cellphones.com.vn/ipad-pro-m4-11-inch.html",
          price: 26990000,
          status: "success",
          errorReason: null,
        },

        {
          index: 7,
          name: "iPad Air 11 inch M4 Wifi 128GB",
          url: "https://cellphones.com.vn/apple-ipad-air-m4-11-inch-128gb-wifi.html",
          price: 16390000,
          status: "success",
          errorReason: null,
        },
      ],
    };
  },

  methods: {
    addProduct() {
      this.products.push({
        index: this.products.length + 1,
        name: "",
        url: "",
        price: 0,
        status: "success",
        errorReason: null,
      });
    },

    removeProduct(index) {
      this.products.splice(index, 1);
    },

    async sendRequest() {
      this.loading = true;

      this.responseData = null;
  let timeRequest = new Date().getTime()    
    try {
        const payload = {

          funcId: this.funcId,
          timeRequest: timeRequest,

          updatedAt: this.updatedAt,
          products: this.products.map((item, index) => ({
            index: index + 1,
            name: item.name,
            url: item.url,
            price: item.price,
            status: item.status,
            error_reason: item.errorReason,
          })),
          cksInput : MD5("28HUADO@hU))8728KKHTD" + timeRequest + this.funcId + this.products.length).toString()
        };

        console.log(payload);

 var pass = "0979951954VienAnCut";
  var url = "https://web.vimass.vn/VMServicesTest/services/device/requestCommand";
  var base64Param = btoa(JSON.stringify(payload));
  var funcId = -99;
  return axios
    .post(
      "https://vimass.vn/VMServices/services/Vpos/requestCommand",
      { pass, url, base64Param, funcId }, {
            headers: {
              "Content-Type": "application/json",
            },
          }
    )
    .then((res) => {
      console.log("res ", res.data.result);
       this.responseData =res.data.result, null, 2;
   
    });

     
      } catch (err) {
        this.responseData = JSON.stringify(err.response?.data.result || err.message, null, 2);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.crawl-page {
  min-height: 100vh;

  padding: 24px;

  background: linear-gradient(rgba(255, 255, 255, 0.72), rgba(255, 255, 255, 0.72)),
    url("https://images.unsplash.com/photo-1497366754035-f200968a6e72?q=80&w=2000")
      center/cover no-repeat fixed;

  font-family: Inter, system-ui, sans-serif;
}

.dashboard-container {
  max-width: 1600px;
  margin: auto;
}

/* HEADER */
.top-header {
  background: linear-gradient(135deg, #22376d, #304b8c);

  border-radius: 18px;

  padding: 22px 28px;

  color: white;

  display: flex;

  align-items: center;

  justify-content: space-between;

  margin-bottom: 24px;

  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
}

.top-header h1 {
  font-size: 38px;
  font-weight: 800;
  margin: 0;
}

.top-header p {
  margin-top: 5px;
  margin-bottom: 0;
  opacity: 0.9;
}

.avatar-box {
  width: 48px;
  height: 48px;

  border-radius: 50%;

  background: rgba(255, 255, 255, 0.15);

  display: flex;

  align-items: center;

  justify-content: center;

  font-size: 22px;
}

/* CARD */
.glass-card {
  background: rgba(255, 255, 255, 0.9);

  border-radius: 20px;

  padding: 22px;

  backdrop-filter: blur(12px);

  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.08);

  border: 1px solid rgba(255, 255, 255, 0.4);
}

.section-title {
  font-size: 26px;

  font-weight: 700;

  margin-bottom: 20px;
}

/* LABEL */
.label-title {
  font-weight: 700;
  font-size: 14px;
}

.label-desc {
  color: #6b7280;

  font-size: 13px;

  margin-bottom: 8px;
}

/* INPUT */
.custom-input {
  width: 100%;

  height: 46px;

  border-radius: 12px;

  border: 1px solid #d6dbe4;

  background: white;

  padding: 0 16px;

  outline: none;

  transition: 0.2s ease;
}

.custom-input:focus {
  border-color: #304b8c;

  box-shadow: 0 0 0 4px rgba(48, 75, 140, 0.1);
}

/* BUTTON */
.btn-add {
  width: 38px;

  height: 38px;

  border: none;

  border-radius: 10px;

  background: #f3f4f6;

  font-size: 24px;

  transition: 0.2s;
}

.submit-btn {
  width: 100%;

  margin-top: 24px;

  height: 54px;

  border: none;

  border-radius: 999px;

  background: linear-gradient(135deg, #22376d, #304b8c);

  color: white;

  font-size: 17px;

  font-weight: 700;

  box-shadow: 0 8px 20px rgba(48, 75, 140, 0.25);
}

/* RIGHT PANEL */
.right-scroll {
  max-height: calc(100vh - 220px);

  overflow-y: auto;

  padding-right: 6px;
}

.right-scroll::-webkit-scrollbar {
  width: 8px;
}

.right-scroll::-webkit-scrollbar-thumb {
  background: #cbd5e1;

  border-radius: 999px;
}

/* GRID */
.product-grid {
  display: grid;

  grid-template-columns: repeat(2, 1fr);

  gap: 16px;
}

/* PRODUCT */
.product-wrapper {
  border-radius: 16px;

  overflow: hidden;

  border: 1px solid #dbe2ea;

  background: #fff;

  height: fit-content;
}

.product-top {
  background: linear-gradient(135deg, #f3f4f6, #f9fafb);

  padding: 14px 16px;

  display: flex;

  align-items: center;

  justify-content: space-between;

  border-bottom: 1px solid #e5e7eb;
}

.product-left {
  display: flex;

  align-items: center;

  gap: 10px;
}

.arrow {
  font-size: 12px;
}

.product-name {
  font-weight: 700;
}

.product-body {
  padding: 16px;
}

.mini-add {
  border: none;

  background: linear-gradient(135deg, #22c55e, #16a34a);

  color: white;

  height: 34px;

  padding: 0 16px;

  border-radius: 10px;

  font-size: 12px;

  font-weight: 700;
}

.mini-remove {
  border: none;

  background: linear-gradient(135deg, #ef4444, #dc2626);

  color: white;

  width: 34px;

  height: 34px;

  border-radius: 10px;

  font-size: 16px;
}

.input-icon {
  position: relative;
}

.input-icon span {
  position: absolute;

  left: 14px;

  top: 50%;

  transform: translateY(-50%);
}

.input-icon input {
  padding-left: 42px;
}

/* RESPONSE */
.response-box {
  margin-top: 24px;

  background: #f3f4f6;

  border-radius: 18px;

  padding: 20px;

  border: 1px solid #dbe2ea;
}

.response-title {
  font-size: 13px;

  color: #15803d;

  font-weight: 700;

  margin-bottom: 14px;
}

.response-box pre {
  margin: 0;

  color: #166534;

  font-size: 14px;

  line-height: 1.7;

  font-family: "Fira Code", monospace;

  white-space: pre-wrap;
}

/* MOBILE */
@media (max-width: 992px) {
  .product-grid {
    grid-template-columns: 1fr;
  }

  .right-scroll {
    max-height: unset;
    overflow: unset;
  }
}

@media (max-width: 768px) {
  .crawl-page {
    padding: 14px;
  }

  .top-header {
    padding: 18px;
  }

  .top-header h1 {
    font-size: 28px;
  }

  .section-title {
    font-size: 22px;
  }
}
</style>
